import axios from 'axios';

const request = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'X-PurrCare-Client': 'PurrCare-Admin/2',
  },
});

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

request.interceptors.response.use(
  (response) => {
    // Unwrap ApiResponse: { success, data, error } -> return data field
    const body = response.data;
    if (body && typeof body === 'object' && 'success' in body) {
      if (!body.success) {
        return Promise.reject(new Error(body.error || 'Request failed'));
      }
      // Return a modified response with data unwrapped
      response.data = body.data;
    }
    return response;
  },
  (error) => {
    const currentToken = localStorage.getItem('admin_token');
    const sentAuthorization = error.config?.headers?.Authorization;
    if (
      error.response?.status === 401 &&
      error.config?.url !== '/admin/login' &&
      currentToken &&
      sentAuthorization === `Bearer ${currentToken}`
    ) {
      // Late failures from an older login/renewal must not erase a newer token.
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/login';
    }
    // Extract error message from API response
    const apiError = error.response?.data?.error;
    if (apiError) {
      error.message = apiError;
    }
    return Promise.reject(error);
  },
);

export default request;
